import styled from "styled-components";
import {SideMenuLinkIconBase} from "../../side-menu-rework/side-menu-link/icons/base/side-menu-link-icon-base.box";
import {styledByTheme} from "../../../themes/architecture/styled-by-theme";

const HelpCenterMenuDefaultIcon = styled(SideMenuLinkIconBase)`
    background-position: -270px -149px;
`;

const HelpCenterMenu777Icon = styled(HelpCenterMenuDefaultIcon)`
    background-position: -25px -526px;
`;

export const HelpCenterMenuIcon = styledByTheme(HelpCenterMenuDefaultIcon).forCasino777(HelpCenterMenu777Icon).apply();